import { render, staticRenderFns } from "./Chinese.vue?vue&type=template&id=2a0a3634&scoped=true&"
import script from "./Chinese.vue?vue&type=script&lang=js&"
export * from "./Chinese.vue?vue&type=script&lang=js&"
import style0 from "./Chinese.vue?vue&type=style&index=0&id=2a0a3634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a3634",
  null
  
)

export default component.exports